import useReferredUsers from "features/affiliation/common/hooks/useReferredUsers";
import { AffiliationTabs } from "features/affiliation/common/types";
import { TIER_TO_DISPLAY_NAME } from "features/affiliation/common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { TranslationKeys } from "@shared/common/i18n/types";
import { LanguageNameSpaces } from "@shared/types";

/** Everything the tier widgets show, derived from the referral history. */
export const useTierSummary = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const { tiers, currentTierData, isLastTier, numActivePaidUsers } =
    useReferredUsers(AffiliationTabs.REFERRED_USERS);
  const currentTier = currentTierData?.tier || 1;
  const top = currentTierData?.top || 0;
  const progressPercent = top
    ? Math.min(100, (numActivePaidUsers / top) * 100)
    : 0;
  const getTierName = (tier: number) =>
    t(
      (TIER_TO_DISPLAY_NAME[tier as keyof typeof TIER_TO_DISPLAY_NAME] ||
        TIER_TO_DISPLAY_NAME[1]) as TranslationKeys<LanguageNameSpaces.AFFILIATION>
    );
  const tierName = getTierName(currentTier);

  return {
    tiers: tiers.slice(0, 3),
    hasTierData: !!currentTierData,
    currentTier,
    progressPercent,
    title: t("tiers.tier_with_name", { tier: currentTier, name: tierName }),
    commission: currentTierData
      ? t("tiers.commission_tag", {
          percent: Math.round(currentTierData.commission_rate * 1000) / 10,
        })
      : undefined,
    inviteText:
      currentTierData && !isLastTier
        ? t("tiers.invite_to_unlock", {
            num: Math.max(0, top - numActivePaidUsers),
            nextTier: currentTier + 1,
          })
        : undefined,
    activeUsers: isLastTier
      ? `${numActivePaidUsers}`
      : `${numActivePaidUsers}/${top}`,
    activeUsersLabel: t("tiers.active_users"),
    getTierName,
  };
};
